import { render, staticRenderFns } from "./ReportsComponent.vue?vue&type=template&id=9f743522"
import script from "./ReportsComponent.vue?vue&type=script&lang=js"
export * from "./ReportsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports